import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/platform-scanner-video-img.png")